export default {
  wishlist: state => state,
  loadingWishlist: state => state.loading
};